<template>
  <div class="mall-shop-member">
    <div class="header-bg-1" v-if="giftDetail.disPlay===2">
      <div class="vip-bg">
        <div class="member-header">
          <div class="title">店铺会员</div>
          <div class="buy-con">
            <div class="price-con">
              <div class="new-price">￥{{ giftDetail.giftSellPrice || 0 }}</div>
              <div class="old-price"><s>原价:￥{{ giftDetail.giftOriginalPrice || 0 }}</s></div>
            </div>
            <div class="btn-con">
              <div class="btn" v-if="giftDetail.giftStatus===2 && giftDetail.disPlay===2" @click="goMallShopMemberBuy">立即开通</div>
            </div>
          </div>
        </div>
        <div class="member-text">会员权益</div>
      </div>
    </div>

    <!--刚开通时，!$route.query.isBuy，展示下方内容-->
    <div class="header-bg-1" v-if="giftDetail.disPlay===1 && !$route.query.isBuy">
      <div class="vip-bg">
        <div class="member-header">
          <div class="title">店铺会员</div>
          <div class="buy-con">
            <div class="price-con">
              <div class="new-price">￥{{ giftDetail.giftSellPrice || 0 }}</div>
              <div class="old-price"><s>原价:￥{{ giftDetail.giftOriginalPrice || 0 }}</s></div>
            </div>
            <div class="btn-con">
              <div class="btn gray-btn">已开通</div>
            </div>
          </div>
        </div>
        <div class="member-text">会员权益</div>
      </div>
    </div>

    <!--刚开通时，$route.query.isBuy==='ok'，展示下方内容-->
    <div class="header-bg-2" v-if="giftDetail.disPlay===1 && $route.query.isBuy==='ok'">
      <div class="is-buy">
        <div class="is-buy-icon-con">
          <div class="icon"></div>
        </div>
        <div class="is-buy-ok-text">开通会员成功！</div>
        <div class="sub-text">课程将在24小时内发放至我的学习，可在 <span style="color: rgb(255,56,56);">我的学习</span> 中查看， 若24小时后仍未收到课程，请联系平台客服人员。</div>
      </div>
    </div>

    <div class="services-con">
      <div class="top"></div>
      <div class="services" v-if="giftDetail.disPlay===2">
        <div class="left-item">
          <div class="icon"></div>
          <div class="text">特定免费课程</div>
        </div>
        <div class="right-item">
          <div class="icon"></div>
          <div class="text">会员专享价</div>
        </div>
      </div>

      <div class="is-buy-services-text" v-if="giftDetail.disPlay===1">
        <span>你已获得以下课程：</span>
      </div>
    </div>
    <div class="gift-service">
      <div class="line"></div>

      <div class="gift-list">
        <goods-list v-for="(item, i) in giftGoods" :key="i" @click.native="goDetail(item)" :item="item"></goods-list>
      </div>
    </div>
    <div class="go-mallShop"><span @click="goMallShop">店铺主页 >></span></div>
  </div>
</template>

<script>
import { giftInfo } from '@/api/member'
import { shopGiftGoods } from '@/api/mall/mallGoods'
import goodsList  from './components/GoodsList';
export default {
  components: {
    goodsList,
  },
  data(){
    return {
      giftDetail: {},//店铺会员礼包详情
      giftGoods: {},//店铺会员礼包中的课程
    }
  },
  created(){
    // this.$route.query.isBuy
    if(this.$route.query.shopId){
      this.getGiftInfo()
    }

  },
  methods: {


    //获取是否拥有店铺会员功能
    getGiftInfo(){
      let req = {shopId: this.$route.query.shopId}
      if(this.session('userOpenId')){
        req.openid=this.session('userOpenId')
      }
      giftInfo(req).then(res=>{
        if(res.code===200){
          this.giftDetail = res.data
          if(res.data.giftList.length){
            this.getGiftProductInfo(res.data.giftList)
          }
        }
      })
    },

    //获取礼包赠送商品
    getGiftProductInfo(giftList){
      let req = {
        shopId: this.$route.query.shopId
      }
      req.productIds = giftList.map(item=>{
        return item.goodsId
      })
      shopGiftGoods(req).then(res=>{
        if(res.code===200){
          // this.giftGoods = res.data
          let list = Object.assign([], res.data)
          this.giftGoods = list.map(item=>{
            let obj = {}
            obj.goodsId = item.goodsId
            obj.filePath = [item.filePath]
            obj.isVipShop = false
            obj.isMemberBag = false
            let goods = {}
            goods.courseType = item.courseType
            goods.productTitle = item.title
            goods.sellPrice = item.sellPrice
            goods.currentCourseCount = item.currentCourseCount
            goods.planCourseCount = 0 //预计更新期数
            goods.duration = item.duration
            goods.collectUserCount = item.collectUserCnt
            goods.salesVolume = item.goodsSalesVolume
            obj.products = [goods]
            return obj
          })

        }
      })
    },

    goMallShopMemberBuy(){
      this.$router.push({name: 'mallShopMemberBuy', query: this.$route.query})
    },

    // 跳转至商品详情
    goDetail(item) {
      // console.log(item)
      // shopId: item.shopId,
      this.$router.push({name: 'goodsDetail', query: {goodsId: item.goodsId, courseType: item.products[0].courseType } })
    },


    //跳转至店铺主页
    goMallShop(){
      this.$router.push({name: 'mallShop', query: this.$route.query})
    },
  }
}
</script>

<style lang="less" scoped>
.mall-shop-member{
  position: relative;
  width: 100%;
  height: 100%;
  .header-bg-1{
    width: 100%;height: 185px;
    position: relative;
    .vip-bg{
      width: 100%;height: 100%;position: absolute;top: 0;z-index: 0;
      background: url("../../assets/mall/mall-shop-member-vip-bg.png") no-repeat 50% 16px;
      background-size: 340px 126.5px;
      .member-header{
        /*position: relative;z-index: 0;*/
        height: 141.5px;
        padding: 32px 17px 0 39px;color: #fff;
        .title{font-size: 25px;margin-bottom: 20px;}
        .buy-con{
          display: flex;
          .price-con{
            flex: 1;display: inline-flex;align-items: flex-end;
            height: 35px;
            .new-price{font-size: 18px;}
            .old-price{font-size: 12px;padding-left: 12px;}
          }
          .btn-con{
            display: inline-flex;justify-content: center;align-items: center;
            width: 140px;
            .btn{
              width: 110px;height: 35px;border-radius: 18px;color: #fa2a37;font-size: 17px;
              display: inline-flex;justify-content: center;align-items: center;
              background-color: #fff;
              &.gray-btn{background-color: #969799;color: #fff;}
            }
          }
        }
      }
      .member-text{
        display: flex;justify-content: center;align-items: center;font-size: 16px;
        width: 100%;height: 45px;color: #000;
        background: url("../../assets/mall/mall-shop-member-line.png") no-repeat 50% 50%;
        background-size: 271px 2.5px;

      }
    }
  }
  .header-bg-2{
    width: 100%;height: 214px;
    position: relative;
    .is-buy{
      height: 100%;
      .is-buy-icon-con{
        display: flex;justify-content: center;align-items: center;
        height: 115px;width: 100%;
        .icon{
          width: 85px;height: 85px;
          background: url("../../assets/mall/mall-shop-member-vip-isbuy.png") no-repeat 50% 50%;
          background-size: 100%;
        }
      }
      .is-buy-ok-text{font-size: 24px;line-height: 40px;text-align: center;color: #fb3737;}
      .sub-text{padding: 15px 36px 17px;color: #333;font-size: 11px;}
    }
  }
  .services-con{
    .top{
      width: 100%;height: 14px;
      background: #f5f5f5 url("../../assets/mall/mall-shop-member-servies-top.png") no-repeat 50% 100%;
      background-size: 34.5px 9.5px;
    }
    .services{
      width: 351px;height: 68px;padding: 0 10px;background-color: #fff;
      border-top-left-radius: 10px;border-top-right-radius: 10px;
      display: flex;margin: 0 auto;padding-top: 8px;
      .left-item, .right-item{
        flex: 1;display: inline-flex;justify-content: center;align-items: center;flex-direction: column;
        .icon{
          width: 29px;height: 29px;margin-bottom: 6px;
          background: url("../../assets/mall/mall-shop-member-icon-1.png") no-repeat 50% 50%;
          background-size: 29px 29px;
        }
        .text{font-size: 13px;color: #333;}
      }
      .right-item{
        .icon{
          background: url("../../assets/mall/mall-shop-member-icon-2.png") no-repeat 50% 50%;
          background-size: 29px 29px;
        }
      }
    }
    .is-buy-services-text{
      font-size: 14px;text-align: center;line-height: 42px;color: #333;
    }
  }
  .gift-service{
    /*position: absolute;*/
    width: 351px;padding-bottom: 40px;
    top: 266.5px;bottom: 0;left: 12px;right: 12px;
    margin: 0 auto;background-color: #fff;
    border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;
    .line{width: 331px;height: 1px;margin: 0 auto;background-color: #eee;}
    .gift-list{
      /*position: absolute;*/
      /*top: 1px;bottom: 38px;*/
      width: 100%;border-radius: 10px;overflow-y: auto;margin: 0 auto;
    }
  }
  .go-mallShop{
    position: fixed;width: 100%;bottom: 0;background-color: #fff;
    line-height: 38px;font-size: 13px;color: #00a6ff;text-align: center;
  }
}
</style>